const Config = require('~/config/default.env').default;

export default {
  API: {
    departmentMenu: `${Config.MS_CATALOG_API_URL}/v3/categories/children`,
    brandsMenu: `${Config.MS_CATALOG_API_URL}/v3/brands`,
    brand: `${Config.MS_CATALOG_API_URL}/v3/brand`,
    tags: `${Config.MS_CATALOG_API_URL}/tags`,
    brandExtra: `${Config.MS_CATALOG_API_URL}/v3/brand-extra`,
    brandsLetter: `${Config.MS_CATALOG_API_URL}/v3/brands/letters`,
    brandsVouchers: `${Config.MS_CART_API_URL}/brand`,
    categoryVoucher: `${Config.MS_CART_API_URL}/category`,
    articleItem: `${Config.MS_BJ_PUBLIC_API_URL}/posts`,
    allHomeBanner: `${Config.MS_CATALOG_API_URL}/banners`,
    products: `${Config.MS_CATALOG_API_URL}/v3/products`,
    peopleAlsoBuy: `${Config.MS_CATALOG_API_URL}/v3/people-also-buy`,
    ourPicks: `${Config.MS_CATALOG_API_URL}/v3/products`,
    whatsNew: `${Config.MS_CATALOG_API_URL}/v3/products`,
    bundlePack: `${Config.MS_CATALOG_API_URL}/v3/products`,
    recentlyViewed: `${Config.MS_CATALOG_API_URL}/v3/product-views`,
    trendingNow: `${Config.MS_CATALOG_API_URL}/v3/products`,
    productWithSameBrand: `${Config.MS_CATALOG_API_URL}/v3/products`,
    bestSellerCategories: `${Config.MS_CATALOG_API_URL}/v3/best-seller`,
    bestSellerItems: `${Config.MS_CATALOG_API_URL}/v3/products`,
    brandItems: `${Config.MS_CATALOG_API_URL}/v3/products`,
    categoryItems: `${Config.MS_CATALOG_API_URL}/v3/products`,
    search: `${Config.MS_CATALOG_API_URL}/search`,
    searchV3: `${Config.MS_CATALOG_API_URL}/v3/search`,
    searchPromo: `${Config.MS_CATALOG_API_URL}/v3/promo/products`,
    products_v2: `${Config.MS_CATALOG_API_URL}/v3/products`,
    reviews: `${Config.MS_REVIEW_API_URL}/reviews`,
    reviews_count_v2: `${Config.MS_REVIEW_API_URL}/reviews/count`,
    reviews_v2: `${Config.MS_SOCO_PUBLIC_API_URL}/reviews`,
    edit_review: `${Config.MS_SOCO_PUBLIC_API_URL}/reviews`,
    searchTag: `${Config.MS_SOCO_PUBLIC_API_URL}/tags`,
    searchTags: `${Config.MS_SOCO_PUBLIC_API_URL}/product/tags`,
    bannerPromo: `${Config.MS_CATALOG_API_URL}/banners`,
    itemsPromo: `${Config.MS_CATALOG_API_URL}/banners`,
    partnerPromo: `${Config.MS_CATALOG_API_URL}/banners`,
    partnerPromoDetail: `${Config.MS_CATALOG_API_URL}/banners`,
    promotions: `${Config.MS_CATALOG_API_URL}/v3/promotions`,
    specialDeals: `${Config.MS_CATALOG_API_URL}/v3/products`,
    wishlist: `${Config.MS_CATALOG_API_URL}/v3/users/me/wishlists`,
    checkboxCart: `${Config.MS_CART_API_URL}/user/me/carts/validate`,
    savedCart: `${Config.MS_CART_API_URL}/user/me/carts/saved-for-later`,
    getAllCarts: `${Config.MS_CART_API_URL}/user/me/carts/all`,
    cart: `${Config.MS_CART_API_URL}/user/me`,
    specialPrices: `${Config.MS_CART_API_URL}/special-price-products`,
    voucherPaperBag: `${Config.MS_CART_API_URL}/user/me/paper-bags`,
    pinkbox: `${Config.MS_CART_API_URL}/extrabags`,
    categoriesDistinct: `${Config.MS_CATALOG_API_URL}/v3/categories/distinct/products`,
    brandsDistinct: `${Config.MS_CATALOG_API_URL}/v3/brands/distinct/products`,
    productPriceRules: `${Config.MS_CATALOG_API_URL}/v3/product-price-rules`,
    vouchers: `${Config.MS_CART_API_URL}/vouchers`,
    login: '/json/v1/login',
    points: `${Config.MS_CART_API_URL}/points`,
    redeemBeautyPoints: `${Config.MS_CART_API_URL}/carts/points`,
    redeemVoucher: `${Config.MS_CART_API_URL}/carts/voucher`,
    payments: `${Config.MS_PAYMENT_API_URL}/payment-methods`,
    paymentDetail: `${Config.MS_PAYMENT_API_URL}/payments`,
    placeOrder: `${Config.MS_ORDER_API_URL}/users/me/orders`,
    detailOrder: `${Config.MS_ORDER_API_URL}/user/me/orders`,
    dataOrder: `${Config.MS_ORDER_API_URL}/order`,
    confirmPayment: `${Config.MS_PAYMENT_API_URL}/payment-confirms`,
    paymentCallback: `${Config.MS_PAYMENT_API_URL}/payments/callback`,
    notifyMe: `${Config.MS_CATALOG_API_URL}/v3/product-availability-alert`,
    brands: `${Config.MS_CATALOG_API_URL}/v3/brands`,
    homePromo: `${Config.MS_CATALOG_API_URL}/v3/brands`,
    recentBought: `${Config.MS_ORDER_API_URL}/users/me/recently-bought`,
    userPhotos: `${Config.MS_SOCO_PUBLIC_API_URL}/products/reviews`,
    userPhotos_v2: `${Config.MS_REVIEW_API_URL}/review-images`,
    campaignStatus: `${Config.MS_CATALOG_API_URL}/v3/promotions/authenticity`,
    birthdayCampaign: `${Config.MS_CATALOG_API_URL}/v3/promotions/sociolla-birthday`,
    offlineStore: `${Config.MS_POS_API_URL}/stores`,
    categoryPath: `${Config.MS_CATALOG_API_URL}/v3/categories/path`,
    me: `${Config.MS_SOCO_PUBLIC_API_URL}/me`,
    userTrackings: `${Config.MS_ANALYTICS_API_URL}/user/me/actions`,
    userSession: `${Config.MS_ANALYTICS_API_URL}/sessions/me`,
    luckyDropVoucher: `${Config.MS_CART_API_URL}/me/vouchers`,
    featuredProduct: `${Config.MS_CATALOG_API_URL}/v3/catalog-rules/detail`,
    fbTracking: `${Config.MS_SOCIOLLA_PUBLIC_API_URL}/fb-conversion`,
    apieuChingu: `${Config.MS_CATALOG_API_URL}/apieu-chingu`,
    trendingSearch: `${Config.MS_SOCO_PUBLIC_API_URL}/search/trending`,
    suggestions: `${Config.MS_CATALOG_API_URL}/v3/search/suggestions`,
    socoGlobalSearch: `${Config.MS_SOCO_PUBLIC_API_URL}/global-search`,
    egiftMessagesTemplate: `${Config.MS_CATALOG_API_URL}/v3/egift-templates`,
  },
  SITE: {
    currency: 'Rp',
    beautyPointBase: 50000,
    limitOrderProduct: 20,
    freeShippingLimit: 200000,
    bankAccount: [
      {
        id: 1,
        name: 'BCA',
        number: '0067686768',
        owner: 'PT Social Bella Indonesia',
        branch: 'KCU SCBD',
      },
      {
        id: 2,
        name: 'MANDIRI',
        number: '0067686769',
        owner: 'PT Social Bella Indonesia',
        branch: 'KCU SCBD',
      },
      {
        id: 2,
        name: 'MANDIRI',
        number: '0067686767',
        owner: 'PT Social Bella Indonesia',
        branch: 'KCU SCBD',
      },
    ],
  },
};
